/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Article Module State
==========================================================================================*/

export default {
  analytcsdata: {
    periode: '0',
    selectedyear: new Date().getFullYear(),
    listData: [],
    userInfo: { Shipped_Not_Invoiced_LCY: 0, Unbilled_returns: 0 }
  },
  articles: [
  ],
  clients: [
  ],
  articleCategories: [{ label: 'L.S.D', value: 'L.S.D' }, { label: 'L.S.', value: 'L.S.' }, { label: 'L.D', value: 'L.D' }],
  artcilelabo: [{ label: 'L.S.D', value: 'L.S.D' }, { label: 'L.S.', value: 'L.S.' }, { label: 'L.D', value: 'L.D' }],
  articleFournisseur: [],
  typeOptions: [{
    label: 'Tous',
    value: 'tous'
  },
  {
    label: 'Médicament',
    value: 'medicament'
  },
  {
    label: 'Parapharmacie',
    value: 'parapharmacie'
  },
  ], fournisseurOptions: [{
    label: 'Tous',
    value: 'tous'
  },
  {
    label: 'L.S.D',
    value: 'L.S.D'
  },
  {
    label: 'Deactivated',
    value: 'deactivated'
  },
  {
    label: 'Blocked',
    value: 'blocked'
  },
  ], laboratoireOptions: [{
    label: 'Tous',
    value: 'tous'
  },
  {
    label: 'Active',
    value: 'active'
  },
  {
    label: 'Deactivated',
    value: 'deactivated'
  },
  {
    label: 'Blocked',
    value: 'blocked'
  },
  ],
  classeOptions: [{
    label: 'Tous',
    value: 'tous'
  },
  {
    label: 'Active',
    value: 'active'
  },
  {
    label: 'Deactivated',
    value: 'deactivated'
  },
  {
    label: 'C000253',
    value: 'C000253'
  },
  ]
}
